<template>
    <t-node :info="nodeInfo" v-if="nodeInfo"></t-node>
   
</template>

<style lang="stylus" rel="stylesheet/stylus" scoped type="text/stylus">
@require '../assets/style/base.styl';

.page.home {
}
</style>

<script type="text/ecmascript-6">
import BasePage from '../extend/BasePage'
import tNode from '../components/Node'
export default {
    name: 'home',
    mixins: [BasePage],
    components: { tNode },
    data: function () {
        return {
            nodeInfo: null,
            isQuickApp: new RegExp('quickapp', 'gi').test(navigator.userAgent),
            scrollCount: 0,
            lastestDeep: null,
        }
    },
    created: function () {
        this.loadPageInfo('created')
    },
    watch: {
        $route(to, from) {
            try {
                // 对路由变化作出响应...
                if (to.path != from.path) {
                    // 如果页面改变。load新页面加入
                    // console.info(
                    //     'route changed process begin',
                    //     to.path,
                    //     from.path
                    // )
                    this.loadPageInfo('watch-route')
                }
            } catch (error) {
                console.error('route changed process error', error)
            }
        },
    },
    methods: {
        loadPageInfo: function (source) {
            // console.log('loadPageInfo', source)
            try {
                if (window.pageInfo) {
                    this.processPageInfo(window.pageInfo)
                    if (window.AllBridge.clientType === window.AllBridge.ClientTypeEnum.TAPP && window.pageInfo.appForceLogin) {
                        window.AllBridge.getUserInfo().then((res) => {
                            if (res && !res.isLogin) {
                                window.AllBridge.login()
                            }
                        })
                    }
                    console.log(
                        'Page',
                        'loadPageInfo',
                        'window上已经有页面信息数据了'
                    )
                    return
                }

                const activityId = this.$route.params.pageKey
                if (!activityId) {
                    console.error(
                        'Page',
                        'loadPageInfo',
                        '缺少页面id，无法去获取页面信息数据'
                    )
                    return
                }

                this.$http({
                    url: this.api.pagesDeatil,
                    method: 'get',
                    headers: {
                        'AllE-Activity-Id':
                            'alle_' + this.$route.params.pageKey,
                    },
                    data: {
                        activityId,
                        historyId: this.$route.query.historyId,
                        draft: this.$route.path.indexOf('/draft/') >= 0,
                    },
                }).then((res) => {
                    if (res && res.data && res.data.code === '0000') {
                        window.pageInfo = res.data.result
                        if (window.AllBridge.clientType === window.AllBridge.ClientTypeEnum.TAPP && window.pageInfo.appForceLogin) {
                            window.AllBridge.getUserInfo().then((res) => {
                                if (res && !res.isLogin) {
                                    window.AllBridge.login()
                                }
                            })
                        }
                        this.processPageInfo(window.pageInfo)
                    }
                })
            } catch (error) {
                console.error('Page', 'loadPageInfo error', error)
            }
        },
        processPageInfo(info) {
            if (!info) {
                return
            }

            window.pageInfo = info
            let nodeInfo = JSON.parse(info.content)
            this.$root.lazyMargin = nodeInfo.lazyMargin
           
            if (!nodeInfo || nodeInfo.id != 'root') {
                // console.warn(
                //     'Page',
                //     'processPageInfo',
                //     '页面节点信息为空，或格式错误'
                // )
                return
            }

            this.loadLibraries(nodeInfo).finally(() => {
                this.allBridge.allReadydo().then((allBridge) => {
                    // nodeInfo.child = nodeInfo.child.map((item) => {
                    //     item.isLazy = true
                    //     return item
                    // })
                    this.nodeInfo = nodeInfo
                    this.setPageTitle(info.displayName)
                    // TODO: 先这么临时处理，回头管理后台添加对应配置项
                    if (
                        info &&
                        info.shareTitle !== '$custom' &&
                        info.shareType !== 2
                    ) {
                        this.initShare(info, allBridge)
                    }

                    // 页面滚动事件公共监听
                    this.listenOnScroll(info, allBridge)
                })
            })
        },
        initShare(info, allBridge) {
            let shareUrl = this.delParam(window.location.href, 'tx_cps_id')
            if (info.shareType == 1 || info.shareType == 3) {
                const shareInfo = {
                    title: info.shareTitle,
                    desc: info.shareDesc,
                    link: shareUrl,
                    img: info.shareDefaultImage,
                    xcximg: info.shareXcxImage,
                    wxId: info.shareType == 3 ? 'gh_0a00573ff7cf' : null,
                    wxPath:
                        info.shareType == 3
                            ? `/page/home/webview/webview?src=${encodeURIComponent(
                                  shareUrl
                              )}${
                                  window['_refid']
                                      ? '&wxrefid=' + window['_refid']
                                      : ''
                              }`
                            : null,
                }
                allBridge.showShareMenu(shareInfo).then(() => {})
            } else {
                allBridge.hideShareMenu().then(() => {})
            }
        },
        delParam(orgUrl, paramKey) {
            try {
                let list = []
                var searchParams = new URLSearchParams(orgUrl.split('?')[1])
                for (var pair of searchParams.entries()) {
                    if (pair[0] !== paramKey) {
                        list.push(pair[1] ? `${pair[0]}=${pair[1]}` : pair[0])
                    }
                }
                let search = list.join('&')
                return search
                    ? orgUrl.split('?')[0] + '?' + search
                    : orgUrl.split('?')[0]
            } catch (err) {
                return orgUrl
            }
        },
        getLibraries(node, libraries) {
            if (libraries === undefined || libraries === null) {
                libraries = []
            }

            if (node.libraries && node.libraries.length > 0) {
                const waitLibraries = []
                for (const iterator of node.libraries) {
                    if (
                        iterator.startsWith('http://') ||
                        iterator.startsWith('https://')
                    ) {
                        waitLibraries.push(iterator)
                    } else if (
                        window.thirdLibrariesMapping &&
                        Object.keys(window.thirdLibrariesMapping) &&
                        Object.keys(window.thirdLibrariesMapping).length > 0 &&
                        Object.keys(window.thirdLibrariesMapping).indexOf(
                            iterator
                        ) >= 0
                    ) {
                        // 快应用环境跳过 appresource_multi_bridge_js 的加载，因为 allBridge 已经引用了
                        if (
                            this.isQuickApp &&
                            iterator === 'appresource_multi_bridge_js'
                        ) {
                            continue
                        }

                        waitLibraries.push(
                            window.thirdLibrariesMapping[iterator]
                        )
                    } else {
                        // console.warn(
                        //     'Page',
                        //     'loadLibraries',
                        //     node.id,
                        //     '依赖第三方库配置不正确',
                        //     iterator
                        // )
                    }
                }

                libraries =
                    waitLibraries && waitLibraries.length > 0
                        ? libraries.concat(waitLibraries)
                        : libraries
            }

            if (node.child && node.child.length > 0) {
                for (const item of node.child) {
                    libraries = this.getLibraries(item, libraries)
                }
            }
            return Array.from(new Set(libraries))
        },
        loadLibraries(nodeInfo) {
            const libraries = this.getLibraries(nodeInfo)
            const librariesSize = libraries && libraries.length
            let loadedLibrariesSize = 0
            return new Promise((resolve, reject) => {
                if (librariesSize >= 0) {
                    for (const item of libraries) {
                        if (item.indexOf('.css') >= 0) {
                            // css 不等待，直接算加载完成
                            loadedLibrariesSize++
                            __loadResource('link', item)
                        } else {
                            __loadResource(
                                'script',
                                item,
                                () => {
                                    loadedLibrariesSize++
                                },
                                () => {
                                    loadedLibrariesSize++
                                }
                            )
                        }
                    }

                    (function checkIsFinished() {
                        if (librariesSize === loadedLibrariesSize) {
                            window.__librariesLoaded = true
                            resolve()
                        } else {
                            if (new Date().getTime() % 5 === 0) {
                                // console.warn(
                                //     'Page',
                                //     'loadLibraries',
                                //     '依赖的第三方库还未加载完成',
                                //     librariesSize,
                                //     loadedLibrariesSize
                                // )
                            }

                            setTimeout(() => {
                                checkIsFinished()
                            }, 100)
                        }
                    })()
                } else {
                    resolve()
                }
            })
        },
        listenOnScroll(info, allBridge) {
            const self = this
            const throttle = (func, wait, options) => {
                /* options的默认值
                 *  表示首次调用返回值方法时，会马上调用func；否则仅会记录当前时刻，当第二次调用的时间间隔超过wait时，才调用func。
                 *  options.leading = true;
                 * 表示当调用方法时，未到达wait指定的时间间隔，则启动计时器延迟调用func函数，若后续在既未达到wait指定的时间间隔和func函数又未被调用的情况下调用返回值方法，则被调用请求将被丢弃。
                 *  options.trailing = true;
                 * 注意：当options.trailing = false时，效果与上面的简单实现效果相同
                 */
                var context, args, result
                var timeout = null
                var previous = 0
                if (!options) options = {}
                var later = function () {
                    previous = options.leading === false ? 0 : Date.now()
                    timeout = null
                    result = func.apply(context, args)
                    if (!timeout) context = args = null
                }
                return function () {
                    var now = Date.now()
                    if (!previous && options.leading === false) previous = now
                    // 计算剩余时间
                    var remaining = wait - (now - previous)
                    context = this
                    args = arguments
                    // 当到达wait指定的时间间隔，则调用func函数
                    // 精彩之处：按理来说remaining <= 0已经足够证明已经到达wait的时间间隔，但这里还考虑到假如客户端修改了系统时间则马上执行func函数。
                    if (remaining <= 0 || remaining > wait) {
                        // 由于setTimeout存在最小时间精度问题，因此会存在到达wait的时间间隔，但之前设置的setTimeout操作还没被执行，因此为保险起见，这里先清理setTimeout操作
                        if (timeout) {
                            clearTimeout(timeout)
                            timeout = null
                        }
                        previous = now
                        result = func.apply(context, args)
                        if (!timeout) context = args = null
                    } else if (!timeout && options.trailing !== false) {
                        // options.trailing=true时，延时执行func函数
                        timeout = setTimeout(later, remaining)
                    }
                    return result
                }
            }

            document.addEventListener('scroll', function () {
                // 页面首次滚动事件
                if (!window['_alle_page_first_scroll_event']) {
                    window['_alle_page_first_scroll_event'] = true
                    const bottom = self.checkIsScrollToBottom()
                    allBridge
                        .allEventTrack({
                            category: 'alle_page',
                            action: 'first_scroll_event',
                            value: { bottom },
                        })
                        .then(function () {})
                }
            })

            // 页面浏览屏数
            document.addEventListener(
                'scroll',
                throttle(() => {
                    this.scrollCount++
                    const scrollTop =
                        document.documentElement.scrollTop ||
                        document.body.scrollTop

                    setTimeout(() => {
                        const deep = self.getScrollDeep(scrollTop)
                        const bottom = self.checkIsScrollToBottom()
                        if (deep && deep > 0 && this.lastestDeep != deep) {
                            this.lastestDeep = deep
                            allBridge
                                .allEventTrack({
                                    category: 'alle_page',
                                    action: 'scroll_bottom_event',
                                    value: { deep, bottom },
                                })
                                .then(function () {})
                        }
                    }, 60)
                }, 60)
            )
        },
        checkIsScrollToBottom() {
            /**
             * 获取距离顶部高度
             */
            const getScrollTop = function () {
                var scrollTop = 0,
                    bodyScrollTop = 0,
                    documentScrollTop = 0
                if (document.body) {
                    bodyScrollTop = document.body.scrollTop
                }
                if (document.documentElement) {
                    documentScrollTop = document.documentElement.scrollTop
                }
                scrollTop =
                    bodyScrollTop - documentScrollTop > 0
                        ? bodyScrollTop
                        : documentScrollTop
                return scrollTop
            }

            /**
             * 获取文档的总高度
             */
            const getScrollHeight = function () {
                var scrollHeight = 0,
                    bodyScrollHeight = 0,
                    documentScrollHeight = 0
                if (document.body) {
                    bodyScrollHeight = document.body.scrollHeight
                }
                if (document.documentElement) {
                    documentScrollHeight = document.documentElement.scrollHeight
                }
                scrollHeight =
                    bodyScrollHeight - documentScrollHeight > 0
                        ? bodyScrollHeight
                        : documentScrollHeight
                return scrollHeight
            }

            /**
             * 获取浏览器视口的高度
             */
            const getWindowHeight = function () {
                var windowHeight = 0
                if (document.compatMode === 'CSS1Compat') {
                    windowHeight = document.documentElement.clientHeight
                } else {
                    windowHeight = document.body.clientHeight
                }
                return windowHeight
            }

            return getScrollTop() + getWindowHeight() === getScrollHeight()
        },
        getScrollDeep(scrollTopOld) {
            const scrollTopNew =
                document.documentElement.scrollTop || document.body.scrollTop
            if (scrollTopOld !== scrollTopNew || this.scrollCount == 1) {
                return
            }
            this.scrollCount = 0
            const deep =
                (scrollTopNew + window.screen.height) / window.screen.height

            const deeps = deep && deep.toString().split('.')

            let result
            if (deeps && deeps.length == 2) {
                result =
                    parseInt(deeps[0]) +
                    (parseFloat('0.' + deeps[1]) < 0.5 ? 0 : 0.5)
            } else {
                result = deep
            }

            return result
        },
        
    },
}
</script>
